export default "__VITE_ASSET__icHiWxAu__"